import { selectors } from "../../redux";
import { useSelector } from 'react-redux';

const useStoreViewCode = () => {
    return useSelector(selectors.storeView.getCode);
}

export default useStoreViewCode;